import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { toast } from 'react-toastify';
import {  useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

import api from '../constants/api';
import PageLoader from '../components/loader';
import ModalUserAdd from '../components/newUserModal';

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: '' },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [addData, setAddData] = useState({});
  const [isEdit, setIsEditData] = useState(false);
  const [editData, setEditData] = useState({});
  const [openNewUser, setOpenNewUser] = useState(false);
  const [roles, setRoles] = useState(false);
  const [location, setLocation] = useState(false);
  const user = useSelector((state) => state?.userReducer?.user?.updatedUser);
  const navi = useNavigate()
  const [USERLIST, setUserList] = useState([]);

  useEffect(() => {
    if (user?.role?.code !== 'admin') {
      navi('/products', { replace: true });
    }
    fetchUsers();
    fetchRoles();
    fetchLocation();
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [page]);

  const fetchRoles = async () => {
    try {
      setLoading(true);

      const response = await api.fetchRoles();

      setRoles(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    }
  };

  const fetchLocation = async () => {
    try {
      setLoading(true);

      const response = await api.fetchLocations();

      setLocation(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    }
  };


  const fetchUsers = async () => {
    console.log('page');
    try {
      setLoading(true);

      const response = await api.fetchUsers({
        page: 1 + page,
        ...(filterName && { email: filterName }),
      });

      setUserList(response.data);
      setCount(response.count);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const saveUser = async () => {
    try {
      setLoading(true);

      if (!addData?.name || !addData?.email || !addData?.role || !addData?.password ) {
        throw new Error('Please fill all the fields');
      }

      const response = await api.registerUser(addData);

      if (page !== 0) setPage(0);
      else {
        fetchUsers();
      }

      toast.success('User added successfully');

      setOpenNewUser(false);
      setAddData({});
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // setOpenNewUser(false);
      // setAddData({});
      toast.error(error.message);
    }
  };

  const editUser = async () => {
    try {
      setLoading(true);

      const changedFields = {};
      console.log(editData, selected);
      Object.keys(editData).forEach((key) => {
        if (key in editData && editData[key] !== selected[key]) {
          if (!editData[key]) {
            throw new Error('Please fill all the fields');
          }
          changedFields[key] = editData[key];
        }
      });

      if (Object.keys(changedFields).length === 0) throw new Error('No changes made');

      changedFields._id = selected._id;

      const response = await api.updateUser(changedFields);

      if (page !== 0) setPage(0);
      else {
        fetchUsers();
      }

      toast.success('User Editted successfully');

      setOpenNewUser(false);
      setIsEditData(false);
      setEditData({});
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    }
  };

  const deleteUser = async () => {
    try {
      setLoading(true);

      const response = await api.updateUser({ _id: selected?._id, isActive: false });

      if (page !== 0) setPage(0);
      else {
        fetchUsers();
      }

      setLoading(false);
      handleCloseMenu();

      toast.success('User deleted successfully');
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    }
  };

  const resetPassword = async () => {
    try {
      setLoading(true);

      const response = await api.requestNewPassword({ _id: selected?._id });

      setLoading(false);
      handleCloseMenu();

      toast.success('Password reset link sent to user email');
    } catch (error) {
      setLoading(false);
      toast.error(error.message);
    }
  };

  const openEditModal = () => {
    setOpen(false);
    setIsEditData(true);
    console.log(selected);
    setEditData(selected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onFocusLost = () => {
    if (page !== 0) setPage(0);
    else {
      fetchUsers();
    }
  };

  const handleOpenMenu = (e, user) => {
    setOpen(e.currentTarget);
    setSelected(user);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setSelected([]);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleOnChange = (e) => {
    if (isEdit) {
      setEditData({ ...editData, [e.target.name]: e.target.value });
      return;
    }

    setAddData({ ...addData, [e.target.name]: e.target.value });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;
  const filteredUsers = USERLIST;
  // const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy));
  const isNotFound = !filteredUsers.length;

  return (
    <>
      {loading && <PageLoader />}

      <ModalUserAdd
        isEdit={isEdit}
        valuesObject={editData}
        selectValues={roles}
        selectLocationVal={location}
        handleSubmit={saveUser}
        handleEditSubmit={editUser}
        onChange={handleOnChange}
        handleClose={() => {
          setEditData({});
          setOpenNewUser(false);
          setIsEditData(false);
        }}
        visible={openNewUser || isEdit}
        text={isEdit ? 'Edit User Details' : 'Add User Details'}
      />

      <Helmet>
        <title> User | Tadashii Motors </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button onClick={() => setOpenNewUser(true)} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            Add New
          </Button>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            onLostFocus={onFocusLost}
            title={'User Records'}
            searchTitle={'Search by email'}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  // order={order}
                  // orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  // onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers.map((row) => {
                    const { _id, name, role, email } = row;
                    return (
                      <TableRow hover key={_id} tabIndex={-1}>
                        <TableCell component="th" scope="row" padding="2">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={name} />
                            <Typography variant="subtitle2" noWrap>
                              {name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{email}</TableCell>

                        <TableCell align="left">
                          <Label color={(role.code === 'admin' && 'primary') || 'success'}>
                            {sentenceCase(role.name)}
                          </Label>
                        </TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )} */}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          {/* <Typography variant="h6" paragraph>
                            Not found
                          </Typography> */}

                          <Typography variant="body2">No results found</Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={count}
            rowsPerPage={5}
            page={page}
            onPageChange={handleChangePage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={openEditModal}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem onClick={deleteUser} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>

        {/* <MenuItem onClick={resetPassword} sx={{ color: 'primary.main' }}>
          <Iconify icon={'eva:refresh-outline'} sx={{ mr: 2 }} />
          Reset
        </MenuItem> */}
      </Popover>
    </>
  );
}
